import { DonationsTransactions } from "./DonationsTransactions";
import { useMintingAttestations } from "../../hooks/useMintingAttestations";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function RoundDonations(_ref) {
  let {
    title,
    contributions = {}
  } = _ref;
  const transactionHashes = Object.keys(contributions);
  const {
    data: mintingAttestations,
    isFetching,
    isLoading,
    refetch
  } = useMintingAttestations(transactionHashes);
  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col gap-6",
    children: [/*#__PURE__*/_jsx("div", {
      className: "flex items-center h-[45px] border-black text-black text-lg/[26px] border-b font-modern-era-medium font-medium",
      children: title
    }), transactionHashes.length === 0 ? /*#__PURE__*/_jsx("div", {
      className: "text-md text-center",
      children: "No Donations found"
    }) : transactionHashes.map(transactionHash => {
      var _mintingAttestations$;
      return /*#__PURE__*/_jsx(DonationsTransactions, {
        transactionHash: transactionHash,
        contributions: contributions[transactionHash],
        transactionAttestationsData: {
          transactionAttestations: mintingAttestations === null || mintingAttestations === void 0 ? void 0 : mintingAttestations[transactionHash],
          attestationUid: mintingAttestations === null || mintingAttestations === void 0 || (_mintingAttestations$ = mintingAttestations[transactionHash]) === null || _mintingAttestations$ === void 0 || (_mintingAttestations$ = _mintingAttestations$[0]) === null || _mintingAttestations$ === void 0 ? void 0 : _mintingAttestations$.attestationUid,
          isFetchingAttestations: isFetching || isLoading,
          refetch
        }
      }, transactionHash);
    })]
  });
}